import type { LucideIcon } from "lucide-react";
import { NetworkIcon } from "lucide-react";

export const OKRS_ORG_CHART_PATH = "/okrs/org-chart" as const;

export type OkrsNavPath = typeof OKRS_ORG_CHART_PATH;

export type OkrsNavItem = {
  description: string;
  icon: LucideIcon;
  id: string;
  isActive: (pathname: string) => boolean;
  label: string;
  to: OkrsNavPath;
};

export const OKRS_NAV_ITEMS: OkrsNavItem[] = [
  {
    id: "org-chart",
    icon: NetworkIcon,
    label: "Org Chart",
    description: "Team structure and reporting lines will live here.",
    to: OKRS_ORG_CHART_PATH,
    isActive: (pathname) =>
      pathname === OKRS_ORG_CHART_PATH || pathname.startsWith(`${OKRS_ORG_CHART_PATH}/`),
  },
];

export function getOkrsNavItem(id: string): OkrsNavItem | undefined {
  return OKRS_NAV_ITEMS.find((item) => item.id === id);
}

export function getOkrsPageTitle(pathname: string): string | null {
  const item = OKRS_NAV_ITEMS.find((navItem) => navItem.isActive(pathname));
  return item?.label ?? null;
}
